import { Drawer } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';

export const DrawerFixed = styled(Drawer)`
  & .shell-drawer-content-wrapper {
    position: fixed;
    width: ${(props) => props.width || '600px'};
    right: 0;
  }
`;

export const LiButton = styled.li<{
  disabled?: boolean;
  appTheme?: 'light' | 'dark';
}>`
  list-style: none;
  padding: 10px;
  border-radius: 4px;
  color: ${(props) => (props.disabled ? 'grey' : 'inherit')};
  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    background-color: ${(props) =>
      props.disabled
        ? 'transparent'
        : props.appTheme === 'dark'
          ? 'rgb(0, 105, 139)'
          : '#f0f0f0'};
  }
`;
